/**
 * SOW-300: this device's proof that the family entered the enrollment invitation's
 * email code (or is signed in here).
 *
 * Core asks each device for the code once; the invitation's saved-card payment
 * endpoints and dashboard-token want the proof in the X-Enrollment-Proof header. The
 * forms-engine iframe, which runs the code step, hands the proof to this page with an
 * `enrollment.device_proof` postMessage; a signed-in family gets one from core directly
 * (API.Post.enrollmentPortalDeviceProof). Kept in memory only: the iframe keeps its own
 * copy and announces it again whenever the embed page loads.
 */
export const ENROLLMENT_DEVICE_PROOF_HEADER = 'X-Enrollment-Proof'

const proofs = new Map<string, string>()

export const setEnrollmentDeviceProof = (invitationToken: string, proof: string): void => {
  if (invitationToken && proof) {
    proofs.set(invitationToken, proof)
  }
}

export const enrollmentDeviceProofFor = (invitationToken: string): string | null =>
  proofs.get(invitationToken) ?? null

/** The invitation token in a public enrollment API URL, if it is one. */
export const enrollmentInvitationTokenFromUrl = (url: string): string | null => {
  const match = /\/api\/enrollment\/invitation\/([^/?#]+)/.exec(url)
  if (!match?.[1]) {
    return null
  }
  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}
